import { UsersIcon, ServerIcon, PuzzleIcon, BriefcaseIcon } from "@heroicons/react/solid";
import { lazy } from "react";
const AnimalResearch = lazy(() => import('../containers/animalResearch/index1'));
const View = lazy(() => import("../containers/view/index"));
const Sales = lazy(() => import("../containers/sales/index.tsx"));
const Images = lazy(() => import("../containers/images/index"));
const ReportAndNote = lazy(() => import("../containers/result/dataAnalusis/dataAnalusis"));
const Finding = lazy(() => import("../containers/result/finding/finding"));
const DataAnalusis = lazy(() => import("../containers/result/dataAnalusis/dataAnalusis"));
const Project = lazy(() => import("../containers/project/index"));
const navigation = (language = "en") => {
  return [
    {
      name: 'Dashboard',
      path: '/dashboard',
      component: Sales,
      icon: ServerIcon,
      exact: true
    },
    {
      name: 'Images',
      path: '/images',
      component: Images,
      icon: ServerIcon,
      exact: true
    },
    {
      name: 'AnimalResearch',
      path: '/animalresearch',
      component: AnimalResearch,
      icon: ServerIcon,
      exact: true
    },
    {
      name: 'Viewerimage',
      path: '/viewerimage/:dzi/:slideid/:animalsid?',
      component: View,
      icon: PuzzleIcon,
      exact: true
    },
    {
      name: 'Project',
      path: '/project',
      component: Project,
      icon: PuzzleIcon,
      exact: true
    },
    {
      name: "Result",
      path: "/result",
      icon: BriefcaseIcon,
      component: ReportAndNote,
      exact: true,
      childrens: [
        {
          name: "ReportAndNOte",
          path: "/result/reportandnote",
          exact: true,
          component: ReportAndNote,
        },
        {
          name: "Finding",
          path: "/result/finding",
          exact: true,
          component: Finding,
        },
        {
          name: "Invoice",
          path: "/result/dataanalysis",
          exact: true,
          component: DataAnalusis,
        }
      ]
    },
    {
      name: "Sales",
      path: "/sales",
      icon: BriefcaseIcon,
      component: Sales,
      exact: true,
      childrens: [
        {
          name: "Porduct List",
          path: "/team/porductlist",
          exact: true,
          component: Sales,
        },
        {
          name: "Billing",
          path: "/team/billing",
          exact: true,
          // component: lazy(),
        },
        {
          name: "Invoice",
          path: "/team/invoice",
          exact: true,
          // component: lazy(),
        }
      ]
    },
    {
      name: "Team Management",
      path: "/team",
      icon: UsersIcon,
      exact: true,
      childrens: [
        {
          name: "Member",
          path: "/team/member",
          exact: true,
          component: lazy(() =>
            import("../containers/team-management/TeamMemberContainer")
          ),
        },
        {
          name: "Invite",
          path: "/team/invite",
          exact: true,
          component: lazy(() =>
            import("../containers/team-management/TeamInviteContainer")
          ),
        },
      ],
    },
  ];
};
export default navigation;
